import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { MenuItemNavLinkWithIcon } from '../MenuItemNavLinkWithIcon';
import { useAuthContext } from '../../../contexts/AuthContext';

export function QuadAdminNavigationMenu() {
    const { user, isLoggedIn } = useAuthContext();

    if (!user.profile) {
        return <div className="float-end" style={{ margin: '38px' }} />;
    }

    return (
        <div
            style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                gap: '4vw',
            }}
        >
            {isLoggedIn && (
                <div className="innerContainer">
                    <button
                        className="btn-no-bg bold quad-nav-item quad-blue uppercase"
                        data-bs-toggle="dropdown"
                    >
                        <span>Quad Admin</span>
                    </button>
                    <div
                        className="dropdown-menu adjust-left"
                        style={{ textTransform: 'uppercase' }}
                    >
                        <MenuItemNavLinkWithIcon
                            icon="fal fa-people-roof"
                            label="Manage"
                            to={LocalRoutes.QuadAdminSameCaseManage}
                        />
                        <MenuItemNavLinkWithIcon
                            icon="fal fa-search"
                            label="Search"
                            to={LocalRoutes.QuadAdminSameCaseSearch}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
